/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
// tab page
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";


import queryString from "query-string";
import ManagerCounselingList from "../../../components/Counseling/ManagerCounselingList";
import Consultings from "../../../components/Consulting/Consultings";

const Pertner = (props) => {
  const history = useHistory();
  const { user, permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
      user: store.Profile.user,
    }),
    shallowEqual
  );

  const [activeTab, setActiveTab] = useState(0);

  const _setActiveTab = (value) => {
    history.push({
      search: `?tab=${value}`
    });
    setActiveTab(value);
  };

  const tabList = [
    {
      label: "담당자 상담",
      action: _setActiveTab,
      value: "managerCounseling",
    },
    {
      label: "상담신청 관리",
      action: _setActiveTab,
      value: "consultings",
    }, {
      label: "무료체험 관리",
      action: _setActiveTab,
      value: "free-trial",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  useEffect(() => {
    // if (!isEmpty(permissions)) {
    //   const permission = permissions.find(
    //     (p) => p.code === "TAX_COUNSELING"
    //   );
    //   setTargetPermission(permission);
    //   if (isEmpty(permission)) {
    //     permissionCheck(history, "TAX_COUNSELING");
    //   }
    // }
  }, [permissions]);


  return (
    // !isEmpty(targetPermission) && (
    <div className="page-content">
      <PageHeader title={`안녕하세요, ${user?.name}님.`}
        activeTab={activeTab}
        tabList={tabList} />
      {activeTab === 'managerCounseling' &&
        <ManagerCounselingList />}

      {activeTab === 'consultings' &&
        <Consultings consultingType={'상담신청'} hideButton={true} />
      }
      {activeTab === 'free-trial' &&
        <Consultings consultingType={'무료체험'} hideButton={true} />
      }
    </div>
    // )
  );
};

export default Pertner;
